class ScrollableImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.foregroundImage = this.querySelector('.scrollable-image__foreground');
    this.revealBar = this.querySelector('.reveal-bar');
    this.revealHalfOnCenter = this.hasAttribute('reveal-half-on-center') || false;

    this.startRevealPoint = this.revealHalfOnCenter
      ? this.startRevealPoint
      : parseInt(this.dataset.startRevealPoint) || 0;

    this.scrollHandler = this.debounce(this.onScroll.bind(this), 10);
    window.addEventListener('scroll', this.scrollHandler);
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  getDistanceFromTopPercentage() {
    const rect = this.getBoundingClientRect();
    const distanceFromTop = rect.top;
    const viewportHeight = window.innerHeight;

    const percentage = this.revealHalfOnCenter
      ? 100 - (50 - ((distanceFromTop + rect.height / 2 - viewportHeight / 2) / viewportHeight) * 100)
      : (distanceFromTop / viewportHeight) * (100 + this.startRevealPoint);

    return Math.max(0, Math.min(percentage, 100));
  }

  onScroll() {
    const visiblePercentage = this.getDistanceFromTopPercentage();

    if (visiblePercentage <= 100 && visiblePercentage >= 0) {
      this.foregroundImage.style.clipPath = `inset(0 0 0 ${visiblePercentage}%)`;
      this.revealBar.style.right = `-${visiblePercentage}%`;
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
  }
}

customElements.define('scrollable-image', ScrollableImage);
